// Single source for the shell's navigation: which tabs exist, their group,
// icon and label, and what the header shows for each. Sidebar and AppHeader
// both read from here.
import {
  Bot, ChartColumn, FolderTree, Gauge, Library, MessageSquare,
  MessageSquareWarning, Plug, ScrollText, Search, ShieldCheck, Workflow,
} from "lucide-react";

const WORKSPACE_ITEMS = [
  { id: "chat", labelKey: "sidebar.navChat", Icon: MessageSquare },
  { id: "search", labelKey: "sidebar.navSearch", Icon: Search },
  { id: "workflow", labelKey: "sidebar.navWorkflows", Icon: Workflow },
  { id: "kb", labelKey: "sidebar.navKnowledgeBase", Icon: Library },
  { id: "analytics", labelKey: "sidebar.navAnalytics", Icon: ChartColumn },
  { id: "agents", labelKey: "sidebar.navAgents", Icon: Bot },
];

const ADMIN_ITEMS = [
  { id: "admin", labelKey: "sidebar.navAdmin", Icon: ShieldCheck },
  { id: "feedback", labelKey: "sidebar.navFeedback", Icon: MessageSquareWarning },
  { id: "audit", labelKey: "sidebar.navAudit", Icon: ScrollText },
  { id: "collections", labelKey: "sidebar.navCollections", Icon: FolderTree },
  { id: "connectors", labelKey: "sidebar.navConnectors", Icon: Plug },
  { id: "loadtest", labelKey: "sidebar.navLoadTest", Icon: Gauge },
];

const ADMIN_ROLE = "admin";

export function navGroupsFor(role) {
  const groups = [{ id: "workspace", labelKey: "sidebar.groupWorkspace", items: WORKSPACE_ITEMS }];
  if (role === ADMIN_ROLE) groups.push({ id: "admin", labelKey: "sidebar.groupAdmin", items: ADMIN_ITEMS });
  return groups;
}

const PAGE_META = Object.fromEntries(
  [...WORKSPACE_ITEMS, ...ADMIN_ITEMS].map(({ id, labelKey }) => [
    id,
    { eyebrowKey: `header.eyebrow.${id}`, titleKey: labelKey },
  ]),
);

export function pageMetaFor(tab) {
  return PAGE_META[tab] || PAGE_META.chat;
}
